import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const slides = [
  {
    img: '/VedanskrixTechnology.png',
    tag: 'Web & Mobile Development',
    title: 'We Build Digital Products That Drive Growth',
    sub: 'Custom websites, mobile apps, and software solutions tailored for your business.',
  },
  {
    img: '/Technology1.png',
    tag: 'UI/UX & Branding',
    title: 'Design That Converts Visitors Into Customers',
    sub: 'Beautiful, user-centred interfaces backed by data and best practices.',
  },
  {
    img: '/Technology2.png',
    tag: 'Digital Marketing & SEO',
    title: 'Get Found Online. Grow Your Business.',
    sub: 'SEO, Google Ads, social media — we put your brand in front of the right people.',
  },
];

const services = [
  { icon: '🌐', title: 'Web Development',       desc: 'Responsive, fast, and SEO-optimised websites built with the latest frameworks.' },
  { icon: '📱', title: 'Mobile App Development', desc: 'Native Android & iOS apps and cross-platform solutions with React Native.' },
  { icon: '🎨', title: 'UI/UX Design',           desc: 'User research, wireframes, prototypes, and pixel-perfect Figma designs.' },
  { icon: '📈', title: 'Digital Marketing',      desc: 'Google Ads, Meta Ads, SEO and content strategy to grow your online presence.' },
  { icon: '🛒', title: 'E-Commerce Solutions',   desc: 'WooCommerce, Shopify, and custom e-commerce stores that sell 24/7.' },
  { icon: '☁️', title: 'Cloud & DevOps',          desc: 'AWS, Azure, CI/CD pipelines, Docker — scalable infrastructure for any load.' },
  { icon: '🤖', title: 'AI & Automation',         desc: 'Chatbots, ML integrations, and workflow automation to save time and cut costs.' },
  { icon: '🔒', title: 'Cyber Security',          desc: 'Penetration testing, vulnerability assessments, and secure code reviews.' },
];

const stats = [
  { value: '200+', label: 'Projects Delivered' },
  { value: '150+', label: 'Happy Clients' },
  { value: '8+',   label: 'Years Experience' },
  { value: '15+',  label: 'Team Members' },
];

const techs = [
  { name: 'React',      color: '#61DAFB', bg: '#E8F9FE', letter: 'Re' },
  { name: 'Node.js',    color: '#3C873A', bg: '#EDFBE8', letter: 'No' },
  { name: 'Python',     color: '#3776AB', bg: '#EEF5FB', letter: 'Py' },
  { name: 'Flutter',    color: '#02569B', bg: '#E8F3FB', letter: 'Fl' },
  { name: 'Laravel',    color: '#FF2D20', bg: '#FEF0EF', letter: 'La' },
  { name: 'WordPress',  color: '#21759B', bg: '#EEF5FA', letter: 'WP' },
  { name: 'AWS',        color: '#FF9900', bg: '#FFF6E6', letter: 'AWS'},
  { name: 'MySQL',      color: '#4479A1', bg: '#EEF5FB', letter: 'My' },
  { name: 'MongoDB',    color: '#47A248', bg: '#EDFBE8', letter: 'Mg' },
  { name: 'Figma',      color: '#F24E1E', bg: '#FEF0EC', letter: 'Fg' },
  { name: 'TypeScript', color: '#3178C6', bg: '#EEF5FB', letter: 'TS' },
  { name: 'Docker',     color: '#2496ED', bg: '#EEF5FB', letter: 'Dk' },
];

const testimonials = [
  { name: 'Ravi Patel',    role: 'CEO, TechStartup',    text: 'Vedanskrix delivered our web app on time and on budget. The quality was outstanding.' },
  { name: 'Priya Shah',    role: 'Founder, RetailBrand', text: 'Our e-commerce sales doubled after Vedanskrix revamped our online store. Highly recommended!' },
  { name: 'Amit Desai',    role: 'MD, ManufacturingCo', text: 'The ERP system they built has streamlined our entire operations. Great team to work with.' },
];

export default function Home() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrent(c => (c + 1) % slides.length), 4500);
    return () => clearInterval(t);
  }, []);

  return (
    <main className="vt-home">

      {/* ── Hero Slider ── */}
      <section className="vt-hero">
        {slides.map((s, i) => (
          <div key={i} className={'vt-hero__slide' + (i === current ? ' active' : '')} aria-hidden={i !== current}>
            <img src={s.img} alt={s.tag} className="vt-hero__img-bg" />
            <div className="vt-hero__overlay" />
            <div className="vt-container vt-hero__content">
              <span className="vt-hero__tag">{s.tag}</span>
              <h1 className="vt-hero__title">{s.title}</h1>
              <p className="vt-hero__sub">{s.sub}</p>
              <div className="vt-hero__actions">
                <Link to="/contact" className="vt-btn vt-btn--orange">Start a Project</Link>
                <Link to="/portfolio" className="vt-btn vt-btn--outline">View Our Work</Link>
              </div>
            </div>
          </div>
        ))}
        {/* Dots */}
        <div className="vt-hero__dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={'vt-hero__dot' + (i === current ? ' active' : '')}
              onClick={() => setCurrent(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
        {/* Arrows */}
        <button className="vt-hero__arr vt-hero__arr--prev" onClick={() => setCurrent(c => (c - 1 + slides.length) % slides.length)} aria-label="Previous">&#8249;</button>
        <button className="vt-hero__arr vt-hero__arr--next" onClick={() => setCurrent(c => (c + 1) % slides.length)} aria-label="Next">&#8250;</button>
      </section>

      {/* ── Stats ── */}
      <section className="vt-stats">
        <div className="vt-container vt-stats__grid">
          {stats.map(s => (
            <div key={s.label} className="vt-stat">
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── Services ── */}
      <section className="vt-section">
        <div className="vt-container">
          <div className="vt-section-head">
            <span className="vt-eyebrow">What We Do</span>
            <h2>Our Technology Services</h2>
            <p>End-to-end digital solutions to help your business grow and scale.</p>
          </div>
          <div className="vt-services-grid">
            {services.map(s => (
              <div key={s.title} className="vt-service-card">
                <div className="vt-service-card__icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <Link to="/services" className="vt-service-card__link">Learn more →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Tech Stack ── */}
      <section className="vt-section vt-section--grey">
        <div className="vt-container">
          <div className="vt-section-head">
            <span className="vt-eyebrow">Technologies</span>
            <h2>Our Tech Stack</h2>
            <p>We use industry-leading technologies to build robust, scalable solutions.</p>
          </div>
          <div className="vt-tech-grid">
            {techs.map(t => (
              <div key={t.name} className="vt-tech-card" style={{ '--tc': t.color, '--tbg': t.bg }}>
                <div className="vt-tech-icon" style={{ background: t.bg, color: t.color }}>{t.letter}</div>
                <span>{t.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Why Choose Us ── */}
      <section className="vt-section vt-section--dark">
        <div className="vt-container">
          <div className="vt-section-head vt-section-head--light">
            <span className="vt-eyebrow vt-eyebrow--gold">Why Vedanskrix Tech</span>
            <h2>Why Businesses Choose Us</h2>
          </div>
          <div className="vt-why-grid">
            {[
              { icon: '🚀', title: 'On-Time Delivery',    desc: 'We respect deadlines. Every project is delivered on schedule without compromising quality.' },
              { icon: '💡', title: 'Innovative Solutions', desc: 'We stay ahead of trends to give your business a competitive edge with modern tech.' },
              { icon: '🤝', title: 'Dedicated Support',    desc: '24/7 post-launch support and maintenance so your product always runs smoothly.' },
              { icon: '💰', title: 'Affordable Pricing',   desc: 'Premium quality at competitive rates. Transparent pricing with no hidden charges.' },
              { icon: '🔧', title: 'Agile Process',        desc: 'Iterative development with regular demos so you stay in control at every stage.' },
              { icon: '📊', title: 'Data-Driven',          desc: 'All decisions backed by analytics and insights to maximise your ROI.' },
            ].map((w, i) => (
              <div key={i} className="vt-why-card">
                <div className="vt-why-icon">{w.icon}</div>
                <h3>{w.title}</h3>
                <p>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Testimonials ── */}
      <section className="vt-section">
        <div className="vt-container">
          <div className="vt-section-head">
            <span className="vt-eyebrow">Testimonials</span>
            <h2>What Our Clients Say</h2>
          </div>
          <div className="vt-testi-grid">
            {testimonials.map((t, i) => (
              <div key={i} className="vt-testi-card">
                <p className="vt-testi-card__text">"{t.text}"</p>
                <div className="vt-testi-card__author">
                  <div className="vt-testi-card__avatar">{t.name[0]}</div>
                  <div>
                    <strong>{t.name}</strong>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <section className="vt-cta-banner">
        <div className="vt-container vt-cta-banner__inner">
          <div>
            <h2>Ready to Build Something Great?</h2>
            <p>Tell us about your project and get a free consultation.</p>
          </div>
          <div className="vt-cta-banner__actions">
            <Link to="/contact" className="vt-btn vt-btn--white">Get Free Quote</Link>
            <Link to="/portfolio" className="vt-btn vt-btn--outline-white">See Our Work</Link>
          </div>
        </div>
      </section>

    </main>
  );
}
